angular.module('app.player.jwPlayer.jwPlayerInternalDirective', [])
  .directive('jwPlayerInternal', [
    function () {
      "use strict";

      return {
        restrict: 'A',
        template: '<div ng-attr-id="{{id}}" ng-init="$emit(\'player_dom_ready\')"></div>',
        scope: false,
        link: function (scope, elm, attrs) {

        }
      }
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/player/jwPlayer/jwPlayerInternalDirective.js